import { render } from "./GoalTitleActivity.vue?vue&type=template&id=698f5bfc"
import script from "./GoalTitleActivity.vue?vue&type=script&lang=js"
export * from "./GoalTitleActivity.vue?vue&type=script&lang=js"
script.render = render

export default script